import React from 'react';
import {Menu} from '@headlessui/react';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '../../../../hooks/useAuth.ts';
import {CogIcon} from '../../../shared/Icons/CogIcon.tsx';
import {LogoutIcon} from '../../../shared/Icons/LogoutIcon.tsx';

export const UserMenu: React.FC = () => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="-m-1.5 flex items-center p-1.5">
        <span className="sr-only">Open user menu</span>
        <img
          className="h-8 w-8 rounded-full bg-gray-50"
          src={user?.photoUrl || 'https://via.placeholder.com/32'}
          alt=""
        />
        <span className="hidden lg:flex lg:items-center">
          <span className="ml-4 text-sm font-semibold leading-6 text-gray-900" aria-hidden="true">
            {user?.displayName || 'User'}
          </span>
        </span>
      </Menu.Button>

      <Menu.Items className="absolute right-0 z-10 mt-2.5 w-80 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
        <div className="px-4 py-3">
          <p className="text-sm">Signed in as</p>
          <p className="truncate text-sm font-medium text-gray-900">{user?.email}</p>
        </div>

        <div className="border-t border-gray-100">
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={() => navigate('/profile/info')}
                className={`${
                  active ? 'bg-gray-50' : ''
                } flex w-full items-center gap-x-3 px-4 py-3 text-sm leading-6 text-gray-900`}
              >
                <CogIcon className="h-5 w-5 text-gray-400" />
                Profile settings
              </button>
            )}
          </Menu.Item>

          <Menu.Item>
            {({ active }) => (
              <button
                onClick={signOut}
                className={`${
                  active ? 'bg-gray-50' : ''
                } flex w-full items-center gap-x-3 px-4 py-3 text-sm leading-6 text-gray-900`}
              >
                <LogoutIcon className="h-5 w-5 text-gray-400" />
                Sign out
              </button>
            )}
          </Menu.Item>
        </div>
      </Menu.Items>
    </Menu>
  );
};
